var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-header d-xl-block d-none"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"nav-item"},[_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('span',{staticClass:"brand-logo"},[_c('b-img',{attrs:{"src":_vm.appLogoImage,"alt":"logo"}})],1)])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }